<template>
    <v-layout v-if="selectedCategory">
        <v-flex>
            <v-layout row wrap>
                <div id="listImgs" class="quicklink-layoutview inner-scrollbar">
                    <span
                        v-if="isQuickLink"
                        class="quicklink-layoutview__info_text"
                        data-qe-id="MyToolsConstants_QuickLinks"
                        >{{ myToolsConstants.QUICK_LINKS.info_text }}</span
                    >
                    <draggable :options="draggableOptions" :list="categoryData.links" @end="changeOrder">
                        <div
                            v-for="(quickLink, index) in categoryData.links"
                            :key="index"
                            class="quicklink-layoutview__image"
                        >
                            <div>
                                <v-img
                                    :src="sizeFormattedImageUrl(quickLink.iconUrl, 150, 150)"
                                    position="center center"
                                    :alt="quickLink.name"
                                    :data-qe-id="'quickLink_Image' + index"
                                ></v-img>
                                <v-flex class="quicklink-layoutview__actions">
                                    <strong :title="quickLink.name" :data-qe-id="'quickLink_title' + index">{{
                                        quickLink.name
                                    }}</strong>
                                    <span :data-qe-id="'quickLink_label' + index">{{ quickLinkLabel(quickLink) }}</span>
                                </v-flex>
                                <v-btn
                                    :id="`hide_unitTest_${index}`"
                                    v-if="isQuickLink"
                                    class="edit-category__btn"
                                    @click="hideIcon(quickLink)"
                                    :data-qe-id="'quickLink_hideBtn' + index"
                                    outline
                                    >{{ appCommonConstants.HIDE }}</v-btn
                                >
                                <v-btn
                                    :id="`add_unitTest_${index}`"
                                    v-if="!isQuickLink"
                                    class="edit-category__btn add"
                                    @click="addIcon(quickLink)"
                                    :data-qe-id="'quickLink_addBtn' + index"
                                    :disabled="addDisabled"
                                    outline
                                    >{{ appCommonConstants.ADD }}</v-btn
                                >
                            </div>
                        </div>
                    </draggable>
                </div>
                <v-flex mr-4>
                    <status-bar :action="saveAction"></status-bar>
                    <v-layout justify-end>
                        <v-btn
                            id="quicklink_btn_cancel"
                            data-qe-id="'quickLinks_Cancel"
                            :disabled="!canSave"
                            @click="cancel"
                            class="primary_btn transparent"
                            >{{ appCommonConstants.CANCEL }}
                        </v-btn>
                        <v-btn
                            id="quicklink_btn_save"
                            :disabled="!canSave || noActiveQuickLinks"
                            data-qe-id="'quickLinks_Save"
                            class="primary_btn"
                            @click="save"
                            >{{ appCommonConstants.SAVE }}</v-btn
                        >
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { storeAction } from '../../../store/storeActions.constant';
import draggable from 'vuedraggable';
import { appCommonConstants } from '../../appCommon.constants';
import { myToolsConstants } from '../mytools.constant.js';
import StatusBar from '../../StatusBar/StatusBar';
import { sizeFormattedImageUrl } from "@/common/utils/cloudinaryUtils";

export default {
    name: 'QuickLinksCategory',
    data: () => ({
        myToolsConstants,
        appCommonConstants,
        categoryData: null,
        isReordered: false,
        sizeFormattedImageUrl,
    }),
    created() {
        this.categoryData = { ...this.selectedCategory };
    },
    watch: {
        selectedCategory() {
            this.categoryData = { ...this.selectedCategory };
        },
    },
    components: {
        StatusBar,
        draggable,
    },
    props: {
        closeQuickLinkDialog: {
            type: Function,
            required: true,
        },
        selectedCategory: {
            type: Object,
            required: true,
        },
        canSave: {
            type: Boolean,
            required: true,
            default: false,
        },
        myQuickLinksLength: {
            type: Number,
            required: true,
        },
        handleCancel: {
            type: Function,
            required: true,
        },
        handleSave: {
            type: Function,
            required: true,
        },
        handleEditedQuickLinks: {
            type: Function,
            required: true,
        },
        handleHideQuickLink: {
            type: Function,
            required: true,
        },
        handleAddQuickLink: {
            type: Function,
            required: true,
        },
    },
    methods: {
        ...mapActions({
            saveQuickLinks: `tools/${storeAction.saveQuickLinks}`,
            getCategoryLinks: `tools/${storeAction.getCategoryLinks}`,
        }),
        changeOrder() {
            this.categoryData.links.forEach((link, index) => {
                link.iconOrder = index;
            });
            this.handleEditedQuickLinks(this.categoryData.links);
        },
        cancel() {
            this.isReordered = false;
            this.handleCancel();
        },
        save() {
            this.handleSave();
        },
        hideIcon(quickLink) {
            this.categoryData.links = this.categoryData.links.filter((item) => item.id !== quickLink.id);
            this.handleEditedQuickLinks(this.categoryData.links);
            this.handleHideQuickLink(quickLink);
        },
        addIcon(quickLink) {
            this.categoryData.links = this.categoryData.links.filter((item) => item.id !== quickLink.id);
            this.handleAddQuickLink(quickLink);
        },
        quickLinkLabel(quickLink) {
            return quickLink.label === this.myToolsConstants.QUICK_LINKS.Resource
                ? ''
                : `${this.myToolsConstants.QUICK_LINKS.My} ${quickLink.label}`;
        },
    },

    computed: {
        ...mapState('actionState', ['actions']),
        saveAction() {
            return this.actions[storeAction.saveQuickLinks];
        },
        draggableOptions() {
            return {
                animation: 300,
                disabled: !this.isQuickLink,
            };
        },
        isQuickLink() {
            return this.selectedCategory.key === this.myToolsConstants.QUICK_LINKS.QuickLinks;
        },
        addDisabled() {
            return this.myQuickLinksLength >= myToolsConstants.QUICK_LINKS.TWENTY_FOUR;
        },
        noActiveQuickLinks() {
            return this.myQuickLinksLength === 0;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../common/styles/_colors.scss';
@import '../../../common/styles/_responsive.scss';

.quicklink-layoutview {
    min-height: 70vh;
    width: 100%;
    position: relative;
    padding: 50px 0 0 10px;
    max-height: 70vh;
    overflow-y: auto;

    .alert__box {
        &__success {
            background: $ypo-gold;
            color: $white;
            position: relative;
            padding: 10px 10px 10px 45px;
            font-size: 12px;
            text-transform: initial;
            line-height: normal;
            margin-bottom: 13px;
            margin-top: 0px;
            margin-left: 5px;

            i {
                font-size: 28px !important;
                color: $white !important;
                position: absolute;
                left: 10px;
                top: 0;
                bottom: 0;
            }
        }

        &__failure {
            background: $ypo-red;
            color: $white;
            position: relative;
            padding: 10px 10px 10px 45px;
            font-size: 12px;
            text-transform: initial;
            line-height: normal;
            margin-bottom: 13px;
            margin-top: 0px;
            margin-left: 5px;

            i {
                font-size: 28px !important;
                color: $white !important;
                position: absolute;
                left: 10px;
                top: 0;
                bottom: 0;
            }
        }
    }

    &__image {
        text-align: center;
        width: 150px;
        display: inline-block;
        vertical-align: top;
        margin-bottom: 30px;
        cursor: move;

        &.sortable-chosen {
            background: $ypo-extra-light-gray;
        }
        .v-image {
            width: 54px;
            left: 50%;
            margin-left: -27px;
        }
    }

    &__actions {
        min-height: 35px;
        margin-top: 5px;

        strong {
            color: $ypo-dark-gray;
            font-size: 10px;
            line-height: 14px;
            text-align: center;
            display: block;
            font-weight: 500;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        span {
            color: $ypo-text-border;
            font-size: 9px;
            line-height: 14px;
            text-align: center;
            display: block;
        }
    }

    &__info_text {
        color: $ypo-gray;
        font-size: 12px;
        line-height: 18px;
        position: absolute;
        left: 25px;
        top: 20px;
    }
    @media (max-width: 767px) {
        padding-top: 15px;
        max-height: calc(100vh - 300px);
        min-height: calc(100vh - 300px);
        &__info_text {
            position: relative;
            left: 0;
            top: 0px;
        }
    }
}

/* grid layout */
/********************************/
.vue-grid-layout {
    background: $white;
    width: 100%;
}

.edit-category__btn {
    font-size: 12px;
    text-transform: inherit;
    border: 1px solid $ypo-red;
    border-radius: 20px;
    color: $ypo-red;
    padding: 2px 20px;
    height: auto;
    margin: 0;
    min-width: auto;

    &.add {
        background: $ypo-green !important;
        border: 1px solid $ypo-green;
        color: $white;
    }

    &.v-btn--disabled {
        border: 1px solid rgba($black, 0.12) !important;
        pointer-events: inherit;
    }
    @include breakpoint(xs) {
        padding: 4px 25px;
    }
}

.item-border {
    border: 1px solid $ypo-gray !important;
    border-radius: 10px;
}

.vue-resizable-handle {
    z-index: 5001;
    position: relative;
    width: 45px;
    height: 45px;
    bottom: 0;
    right: 0;
    background-position: bottom right;
    padding: 0 3px 3px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}

.vue-grid-item:not(.vue-grid-placeholder) {
    background: $white;
    border: 1px solid $white;
    text-align: center;
}

.vue-grid-item.resizing {
    opacity: 0.9;
}

.vue-grid-item.static {
    background: $white;
}

.vue-grid-item {
    :hover {
        cursor: pointer;
    }
}
</style>
